import React, { useState } from 'react'
import SaveFileModal from './SaveFileModal'
import { Button } from 'react-bootstrap'
import PropTypes from 'prop-types'


export default function FileListChange({selectedRows, resetSelectedRows, fileLength}) {
  const [ showSave, setShowSave ] = useState(false)
  return (
    <div>
      <Button  disabled={fileLength<=0} style={{marginLeft: '9px'}} variant="secondary" size="md" onClick={(e) => {
        e.preventDefault()
        setShowSave(true)
      }}>Save Changes</Button>
      <SaveFileModal selectedRows={selectedRows} show={showSave} onHide={() => {
        setShowSave(false)
      }}
      onClear={() => {
        resetSelectedRows()
      }}
      />
    </div>
  )
}

FileListChange.propTypes = {
  resetSelectedRows: PropTypes.func,
  selectedRows: PropTypes.any,
  fileLength: PropTypes.any
}
